import { CarbonIconType } from '@carbon/icons-react';
import {
  Account,
  Box,
  Delivery,
  Earth,
  Finance,
  Home,
  ResultNew,
  Scan,
  Settings,
  ShoppingCartPlus,
  UserMultiple,
  UserProfile,
} from '@carbon/react/icons';
import { NavCapability } from 'src/config/settingsNav';

export interface MainNavItem {
  path: string;
  labelKey: string;
  icon: CarbonIconType;
  match: string;
  excludeMatch?: string[];
  exact?: boolean;
  capability?: NavCapability;
  requiresSelfEmployee?: boolean;
  pinBottom?: boolean;
}

export function isMainNavItemActive(item: MainNavItem, pathname: string): boolean {
  if (item.exact) {
    return pathname === item.match;
  }
  if (!pathname.includes(item.match)) {
    return false;
  }
  return !(item.excludeMatch || []).some((excluded) => pathname.includes(excluded));
}

export const mainNav: MainNavItem[] = [
  { path: '/dashboard/selling', labelKey: 'sideNav.dashboard', icon: Home, match: '/dashboard' },
  { path: '/pos', labelKey: 'sideNav.pos', icon: ShoppingCartPlus, match: '/pos' },
  { path: '/delivery', labelKey: 'sideNav.delivery', icon: Delivery, match: '/delivery' },
  { path: '/kitchen', labelKey: 'sideNav.kitchen', icon: Scan, match: '/kitchen' },
  { path: '/orders/today', labelKey: 'sideNav.orders', icon: Account, match: '/orders' },
  {
    path: '/accounting/transactions',
    labelKey: 'sideNav.accounting',
    icon: Finance,
    match: '/accounting',
    excludeMatch: ['/dashboard', '/settings', '/storefront'],
  },
  {
    path: '/inventory/items',
    labelKey: 'sideNav.inventory',
    icon: Box,
    match: '/inventory',
    excludeMatch: ['/dashboard', '/settings', '/storefront'],
  },
  {
    path: '/employees/all',
    labelKey: 'sideNav.employees',
    icon: UserMultiple,
    match: '/employees',
    excludeMatch: ['/dashboard', '/settings', '/storefront'],
  },
  {
    path: '/me',
    labelKey: 'sideNav.myEmployment',
    icon: UserProfile,
    match: '/me',
    exact: true,
    requiresSelfEmployee: true,
  },
  {
    path: '/issues/all',
    labelKey: 'sideNav.issues',
    icon: ResultNew,
    match: '/issues',
    excludeMatch: ['/employees', '/dashboard', '/settings', '/storefront'],
  },
  {
    path: '/storefront',
    labelKey: 'sideNav.storefront',
    icon: Earth,
    match: '/storefront',
    capability: 'canManageRestaurantSettings',
  },
  { path: '/settings', labelKey: 'sideNav.settings', icon: Settings, match: '/settings', pinBottom: true },
];
